import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getSelectedClaimDetails, getClaimsDetails, getStatus, Status } from 'redux/reducers/claims'
import { useLocation } from 'react-router-dom'
import { ClaimDetailsRequest } from '@cms-max/medicare-api-sdk'
import { ClaimInformation } from 'containers/Claims/components/ClaimInformation'
import { ClaimQualityLinks } from 'containers/Claims/components/ClaimQualityLinks'
import { ClaimPaymentSummary } from '../components/ClaimPaymentSummary'
import { ClaimProcedures } from 'containers/Claims/components/ClaimProcedures'
import { MySpinner } from 'components/MySpinner/MySpinner'
import { getModalType } from 'redux/reducers/modal'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { ClaimsSubRouteLayout } from '../components/ClaimsSubRouteLayout'

export const ClaimDetails: FC = () => {
  const { t } = useTranslation('claimsSearch', { keyPrefix: 'claimDetails' })
  const modalTypeOpen = useSelector(getModalType)
  const location = useLocation()
  const req = location.state as ClaimDetailsRequest
  const dispatch = useDispatch()
  const details = useSelector(getSelectedClaimDetails)
  const status = useSelector(getStatus)
  // Only display the spinner if the modal isn't open, otherwise is causes the modal to close while status == loading when submiting the form
  const isLoading = status === Status.LOADING && !modalTypeOpen
  const isError = status === Status.ERROR || details.error

  useEffect(() => {
    dispatch(getClaimsDetails(req))
  }, [req, dispatch])

  return (
    <>
      <ClaimsSubRouteLayout pageHeading={t('claimDetailsHeading')}>
        <div className='ds-l-container my-c-claim-details'>
          <div className='ds-l-row'>
            <div className='ds-l-col--12'>
              {(isLoading && !isError) && (
                <MySpinner />
              )}
              {(!isLoading && !isError) && (
                <>
                  <div>
                    <ClaimInformation claim={details.claim} request={req}></ClaimInformation>
                  </div>
                  <div className='ds-u-margin-top--5'>
                    <ClaimPaymentSummary claim={details.claim}></ClaimPaymentSummary>
                  </div>
                  <div className='ds-u-margin-top--5'>
                    <ClaimProcedures claim={details.claim}></ClaimProcedures>
                  </div>
                  {details.claim?.providerDetails?.providerType && (
                    <div className='ds-u-margin-top--5'>
                      <ClaimQualityLinks claim={details.claim}></ClaimQualityLinks>
                    </div>
                  )}
                </>
              )}
              {isError && (
                <Alert variation='warn' role='alert' hideIcon={true}>
                  <p className="ds-c-alert__text">{t('errorMessage')}</p>
                </Alert>
              )}
            </div>
          </div>
        </div>
      </ClaimsSubRouteLayout>
    </>
  )
}
